routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.reportBillfold', {
      url: "reportes/cartera",
      template: `<billfold sh-ctrl="shCtrl"></billfold>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/reports/billfold/billfold.config.js
 **/